import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasSession } from './session-state';

export const loginGuard: CanActivateFn = () =>
  hasSession() ? inject(Router).createUrlTree(['/']) : true;
